import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ProjectType, BudgetYearDropdownOption } from '../../../utils/enums';
import { RouteUrls } from '../../../configs/routeUrls';

export class SearchListItem extends Component {
	constructor(props) {
		super(props);

		this.getProjectTypeSettings = (type, isAuth = false) => {
			switch (type) {
				case ProjectType.Consultation:
					return {
						url: isAuth
							? RouteUrls.Consultation.voteFunc(this.props.id)
							: RouteUrls.Consultation.previewFunc(this.props.id),
						name: 'Konsultacja',
						colorClass: 'bag--warning'
					};
				case ProjectType.Survey:
					return {
						url: isAuth
							? RouteUrls.Survey.voteFunc(this.props.id)
							: RouteUrls.Survey.previewFunc(this.props.id),
						name: 'Ankieta',
						colorClass: 'bag--darkness_blue'
					};
				case ProjectType.PublicBudget:
					return {
						url: isAuth
							? RouteUrls.Budget.vote.voteFunc(this.props.budgetYearValue, this.props.id)
							: RouteUrls.Budget.vote.previewFunc(this.props.budgetYearValue, this.props.id),
						name: 'Budżet',
						colorClass: 'bag--alt'
					};
				case ProjectType.ProjectTask:
					return {
						url: RouteUrls.Budget.projectTasks.previewFunc(this.props.id),
						name: 'Projekt BO',
						colorClass: 'bag--focus'
					};
				default:
					return {
						url: '',
						name: '',
						colorClass: ''
					};
			}
		};
	}
	render() {
		const { isAuth } = this.props;
		let { url, name, colorClass } = this.getProjectTypeSettings(this.props.type, isAuth);
		return (
			<div className="search-list__item">
				<div className="search-list__item-tags">
					<div className="text text--primary">
						<span className={`bag ${colorClass}`}>{name}</span>
					</div>
					<div>
						<Link
							className="search-list__item-name link link--secondary link"
							to={url}
							title={this.props.title}
						>
							<span aria-hidden="true">{this.props.title}</span>
							<i
								className="fas fa-chevron-rigth link--secondary-lighten link__icon link__icon-right"
								aria-hidden="true"
							/>
						</Link>
					</div>
					<div className="search-list__item-target text">{this.props.shortDescription}</div>
				</div>
			</div>
		);
	}
}

SearchListItem.defaultProps = {
	id: 0,
	type: ProjectType.Consultation,
	title: '',
	shortDescription: '',
	budgetYearValue: BudgetYearDropdownOption.NotSetted,
	isAuth: false
};
